import { FormDownload } from 'src/components/form-download';

export default FormDownload;
